<template lang="pug">
  v-expansion-panel-content.app-expansion-panel-content(
    v-bind="$attrs"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
// ВРЕМЕННОЕ РЕШЕНИЕ!
// В дальнейшем глобально стилизовать панели и избавиться от этих компонентов
export default {
};
</script>
